var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  id: "Request_Latest_Price",
  width: 16,
  height: 16,
  viewBox: "0 0 16 16"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  id: "Request_Latest_Price_ContentHolder",
  width: 16,
  height: 16,
  fill: "#fff",
  opacity: 0
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  id: "Request_Latest_Price_Icon",
  d: "M8,3A6.382,6.382,0,0,0,3.844,4.533a.533.533,0,1,0,.693.81,5.334,5.334,0,0,1,8.771,3.523H11.733l2.133,3.2L16,8.867H14.373A6.406,6.406,0,0,0,8,3ZM2.133,6.733,0,9.933H1.627a6.4,6.4,0,0,0,10.529,4.333.533.533,0,1,0-.693-.81A5.334,5.334,0,0,1,2.693,9.933H4.267Z",
  transform: "translate(0 -1)",
  fill: "#212121"
})));
export default __webpack_public_path__ + "static/media/requestIcon.c4dc4033.svg";
export { SvgComponent as ReactComponent };